module.exports = __webpack_public_path__ + "assets/bf3a8a8c919b863f5ebe8e9f4aff9be8.mp3";